import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

export function ScrollToTop() {
  const { pathname } = useLocation()

  // biome-ignore lint/correctness/useExhaustiveDependencies: pathname変化時にスクロールトップする
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return null
}
